/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SysquePropertiesListComponent } from './sysque-properties-list.component';
import { DxTextBoxModule } from 'devextreme-angular';

@NgModule({
  declarations: [SysquePropertiesListComponent],
  imports: [CommonModule, DxTextBoxModule],
  exports: [SysquePropertiesListComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class SysquePropertiesListModule {}
